import { render } from "./plantasForm.vue?vue&type=template&id=58b6e1ea&scoped=true"
import script from "./plantasForm.vue?vue&type=script&lang=js"
export * from "./plantasForm.vue?vue&type=script&lang=js"

import "./plantasForm.vue?vue&type=style&index=0&id=58b6e1ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b6e1ea"]])

export default __exports__